module.exports = __webpack_public_path__ + "static/media/globe.b11b2e57.svg";